import React, { Component } from 'react';
import { Button, Icon, Input, Grid, Label, Modal, Divider, Popup, Dropdown, Feed } from 'semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import Summary from './PracticeCommunitySwimLineCommanPane/Summary';
import AssignRole from './PracticeFlow/Roles';
import Dependencies from './PracticeFlow/Dependencies';
import References from './PracticeCommunitySwimLineCommanPane/References';
import objectId from '../../../../helpers/objectId';
import { isBlockedBySubscriptionLimit } from '../../../../helpers/subscriptionLimitCheck';
import { isBlockedByActiveGeneration } from '../../../../helpers/playbookGenerationCheck';
import Notes from './IndesignComponent/Notes'
import NotesModal from './../drive/modals/Notes'
import FileUploader from '../../../drive/Attachments/UppyFileUpload';
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import ShowPlaybookMetaData from "../drive/modals/ShowPlaybookMetaData";
import ShowPlaybookMetaDataSchema from "../drive/modals/ShowPlaybookMetaDataSchema";
import SchemaModalForm from '../../../drive/FormBuilder/SchemaModalForm';
import { toastr } from 'react-redux-toastr';
import { Form } from 'formsy-semantic-ui-react';
import RegenatePlaybookActivitiesModal from '../DesignerPane/Practice/RegenatePlaybookActivitiesModal';
import ProcessComponent from './ProcessComponent';
var moment = require('moment');
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class PracticeCommunitySwimLineCommanPane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: null,
            openNotesModel: false,
            clickStatus: '',
            modalFlag: false,
            schema:null,
            shemaUpdationKey:"",
            metadataSchemaFlag:false,
            editItem: null,
            action: "",
            schemaJSON: false,
            webSearchLoading : false,
            generateActivitiesFlag : false,
            generateDetailsOpen: false,
            errors: [],
            errors2: []
        }
        this.editActivity = this.editActivity.bind(this);
        this.propagateChangesToChildren = this.propagateChangesToChildren.bind(this);
        this.webSearch = this.webSearch.bind(this);
        this.generateDetails = this.generateDetails.bind(this);
        this.generateActivities = this.generateActivities.bind(this);
    }

    notesClick = (open, clickStatus) => {
        this.setState({ openNotesModel: open, clickStatus: clickStatus })
    }

    propagateChangesToChildren() {
        this.props.selectedPracticeFlowActivity.applyChangesOnChildren = true;
        this.props.selectedPracticeFlowActivity.packId = this.props.selectedPracticeLibrary._id;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }

    editActivity() {
        this.props.selectedPracticeFlowActivity.applyChangesOnChildren = false;
        this.props.selectedPracticeFlowActivity.packId = this.props.selectedPracticeLibrary._id;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }

    generateActivities = async () => {
        const { accountSubscriptionDetail } = this.props
        let defaults = accountSubscriptionDetail.consumptionDefaults || {};
        let requiredCredits = defaults.activitiesGenerated * 7;
        if (isBlockedBySubscriptionLimit({
            accountSubscriptionDetail,
            selectedAccount: this.props.selectedAccount,
            user: this.props.user,
            requiredCredits,
            entity: "Actvities",
            entityType: "AI Generation for Activities",
        })) {
            // blocked, modal shown by helper
        } else if (await isBlockedByActiveGeneration({ accountId: this.props.selectedAccount._id })) {
            // blocked, modal shown by helper
        } else {
            await this.checkContent();
            if(this.state.errors2 && this.state.errors2.length<1 && this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.raci && this.props.selectedPracticeFlowActivity.raci.a && this.props.selectedPracticeFlowActivity.raci.a.length>0 && this.props.selectedPracticeFlowActivity.raci.r && this.props.selectedPracticeFlowActivity.raci.r.length>0){
                let message = <div className="confirmMessage">
                    <h3>Regenerate Stage Activities</h3>
                    <label>{this.props.selectedPracticeFlowActivity.name}</label>
                    <p>Do you want to generate new activities in <b>"{this.props.selectedPracticeFlowActivity.name}"</b></p>
                    <p>NOTE: This action will also delete the activities and the links and metadata of the activities in <b>"{this.props.selectedPracticeFlowActivity.name}"</b></p>
                    <p>Do you want to duplicate your playbook first and then come back to proceed?</p>
                    <span >This action is not reversible</span>
                </div>
                toastr.confirm(message, {
                    onOk: async () => {
                    this.setState({generateActivitiesFlag : true})
                    await dispatch.lifeCycle.getLeafNodeActivities(this.props.selectedPracticeFlowActivity);
                    this.setState({generateActivitiesFlag : false})
                    }
                });
            } else {
                let message = <div className="confirmMessage">
                    <h4>Information</h4>
                    {this.state.errors2.map((error, i) => {
                        return (
                            <div key={i} style={{marginTop:"20px"}} className="error_body">
                                <div className="error_desc">
                                    <strong>{error.phase} {error.stage ? <Icon name="angle right" /> : ""}{error.stage ? error.stage : ""} {error.activity ? <Icon name="angle right" /> : ""} {error.activity ? error.activity : ""} </strong> <br />
                                    <span>{error.description}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
                toastr.confirm(message, {
                    onOk: async () => {
                    },
                    disableCancel: true
                });
            }
        }
    }

    checkContent = async () => {
        let errors = []
        let errors2 = []
        if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.activities) {
            for (const phase of this.props.selectedPracticeLibrary.activities) {
                if((phase._id).toString() === (this.props.selectedPracticeFlowActivity.parentActivity._id).toString()){
                    if (!phase.raci || (phase.raci && !phase.raci.a && (!phase.raci.r || phase.raci.r.length === 0))) {
                        errors.push(`Activity ${phase.name} must have Accountable & Responsible mapping`);
                        errors2.push({
                            type: "configure",
                            phase: phase.name,
                            description: "Must have at least one Accountable & Responsible mapping"
                        });
                    }
                    else {
                        if (!phase.raci.a) {
                            errors.push(`Activity ${phase.name} must have Accountable mapping`);
                            errors2.push({
                                type: "configure",
                                phase: phase.name,
                                description: "Must have at least one Accountable mapping"
                            });
                        }
                        if (!phase.raci.r || phase.raci.r.length === 0) {
                            errors.push(`Activity ${phase.name} must have Responsible mapping`);
                            errors2.push({
                                type: "configure",
                                phase: phase.name,
                                description: "Must have at least one Responsible mapping"
                            });
                        }
                    }
                    if (phase.activities) {    
                        for (const stage of phase.activities) {
                            if (!stage.raci || (stage.raci && !stage.raci.a && (!stage.raci.r || stage.raci.r.length === 0))) {
                                errors.push(`Activity ${phase.name} > ${stage.name} must have Accountable & Responsible mapping`);
                                errors2.push({
                                    type: "configure",
                                    phase: phase.name,
                                    stage: stage.name,
                                    description: "Must have at least one Accountable & Responsible mapping"
                                });
                            }
                            else {
                                if (!stage.raci.a) {
                                    errors.push(`Activity ${phase.name} > ${stage.name} must have Accountable mapping`);
                                    errors2.push({
                                        type: "configure",
                                        phase: phase.name,
                                        stage: stage.name,
                                        description: "Must have at least one Accountable"
                                    });
                                }
                                if (!stage.raci.r || stage.raci.r.length === 0) {
                                    errors.push(`Activity ${phase.name} > ${stage.name} must have Responsible mapping`);
                                    errors2.push({
                                        type: "sequence",
                                        phase: phase.name,
                                        stage: stage.name,
                                        description: "Must have at least one Responsible"
                                    });
                                }
                            }
                            if (stage.activities) {
                                for (const activity of stage.activities) {
                                    if (activity) {
                                        if (!activity.raci || (activity.raci && !activity.raci.a && (!activity.raci.r || activity.raci.r.length === 0))) {
                                            errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Accountable & Responsible mapping`);
                                            errors2.push({
                                                type: "sequence",
                                                phase: phase.name,
                                                stage: stage.name,
                                                activity: activity.name,
                                                description: "Must have at least one Accountable & Responsible"
                                            });
                                        }
                                        else {
                                            if (!activity.raci.a) {
                                                errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Accountable mapping`);
                                                errors2.push({
                                                    type: "sequence",
                                                    phase: phase.name,
                                                    stage: stage.name,
                                                    activity: activity.name,
                                                    description: "Must have at least one Accountable"
                                                });
                                            }
                                            if (!activity.raci.r || activity.raci.r.length === 0) {
                                                errors.push(`Activity ${phase.name} > ${stage.name} > ${activity.name} must have Responsible mapping`);
                                                errors2.push({
                                                    type: "sequence",
                                                    phase: phase.name,
                                                    stage: stage.name,
                                                    activity: activity.name,
                                                    description: "Must have at least one Responsible"
                                                });
                                            }
    
                                        }
                                    }
                                }
                            }    
                        }
                    }
                }
            }
            this.setState({ errors: errors, errors2: errors2 })
        }
    }

    generateStageActivitiesFlag = () =>{
        if(this.props.selectedPracticeLibrary 
			&& !this.state.generateActivitiesFlag
			&& typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined' 
            && this.props.selectedPracticeLibrary.playbookGenerationStatus >= 0
            && this.props.selectedPracticeLibrary.playbookGenerationStatus !== 1
			&& this.props.selectedPracticeFlowActivity){
			return false;
		} else {
			return true;
		}
    }

    generateActivityFlag = () => {
        if(this.props.selectedPracticeLibrary
            && typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined' 
            && this.props.selectedPracticeLibrary.playbookGenerationStatus >= 0  
			&& this.props.selectedPracticeLibrary.genParams 
			&& this.props.selectedPracticeLibrary.genParams.length > 0
            && this.props.selectedPracticeLibrary.playbookGenerationStatus !== 1
            && !this.state.generateActivitiesFlag
			){
			return true;
		} else {
			return false;
		}   
    }

    generateDetails = async (payload) => {
		this.setState({generateDetailsOpen:payload})
	};

    webSearch=async () => {
        const { accountSubscriptionDetail } = this.props
        let defaults = accountSubscriptionDetail.consumptionDefaults || {};
        let requiredCredits = defaults.linksGenerated * 7;
        if (isBlockedBySubscriptionLimit({
            accountSubscriptionDetail,
            selectedAccount: this.props.selectedAccount,
            user: this.props.user,
            requiredCredits,
            entity: "Actvities",
            entityType: "Link Generation for Activities",
        })) {
            // blocked, modal shown by helper
        } else if (await isBlockedByActiveGeneration({ accountId: this.props.selectedAccount._id })) {
            // blocked, modal shown by helper
        } else {
            let message = <div className="confirmMessage">
            <h3>Generate Activity Details</h3>
            <label style={{font:"bold"}}>{this.props.selectedPracticeFlowActivity.name}</label>
            <p>For this one activity, this action will delete and then generate new attachments and metadata of <b>"{this.props.selectedPracticeFlowActivity.name}"</b></p>
            <p>Are you sure you want to generate the activity details?</p>
            <span >This action is not reversible</span>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    this.setState({ webSearchLoading : true })
                    // await dispatch.lifeCycle.webSearch();
                    let payload = {
                        _id: this.props.selectedPracticeFlowActivity._id,
                        metaData: this.props.selectedPracticeFlowActivity.metaData,
                        generatingActivities: [this.props.selectedPracticeFlowActivity._id]
                    }
                    await dispatch.lifeCycle.generateDetailsOfSingleLeafNodeActivity(payload);
                    this.setState({ webSearchLoading : false })
                }
            });
        }
    }

    componentWillMount() {
        // sessionStorage.setItem("actid", this.props.selectedPracticeFlowActivity._id)
        dispatch.lifeCycle.modalRoleChangeOpen(false);
        dispatch.createPack.contentModalOpen(false);
        dispatch.createPack.setValidationCheckFlag(false);
    }
    componentWillReceiveProps() {
        if (this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.overrideChildren) {
            this.props.selectedPracticeFlowActivity.overrideChildren = false;
        }
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.editItem !== this.props.selectedDataItem) {
    //         this.setState({editItem: this.props.selectedDataItem})
    //     }
    // }
    handleUppyModalClick = () => {
        this.setState({
            openDashboard: !this.state.openDashboard
        });
    }

    close = () => {
        this.setState({ linkOpen: false, name: '', url: '' })
    }

    addLink = () => {
        let attachments = this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.attachments ? this.props.selectedPracticeFlowActivity.attachments : [];
        let document = {};
        document.documentName = this.state.name;
        document.documentId = objectId();
        document.documentUrl = this.state.url;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();
        attachments.unshift(document);
        this.addAttachment(attachments)
        this.close()
    }

    addAttachment = (attachments) => {
        let attachmentPayload = {
            _id: this.props.selectedPracticeFlowActivity._id,
            name: this.props.selectedPracticeFlowActivity.name,
            data: {
                attachments: attachments
            }
        }
        dispatch.lifeCycle.updateAttachnmentInActivity(attachmentPayload);
    }
    isAuthor = () => {
        const loggdinUserId = this.props.user.email;
        let author =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
          });
        if (author && author.length > 0) {
          return author.find((author) => author.email === loggdinUserId);
        }
        return null;
      };

       isContributor = () => {
        const loggdinUserId = this.props.user.email;
        let contributor =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "contributor";
          });
        if (contributor && contributor.length > 0) {
          return contributor.find((contributor) => contributor.email === loggdinUserId);
        }
        return null;
      };
      isWorkspaceOwner = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };
      setMetadataSchemaModalFlag = async (flag) => {
        
        await dispatch.createPack.setSelectedDataItem(null)
        this.setState({ metadataSchemaFlag: flag, editItem: null, action: "Add"});
      };
      setSchemaJsonFlag = (flag) => {
        this.setState({schemaJSON: flag})
      }
      setItemToEdit = async (data) => {
        // sessionStorage.setItem("actdata", data)
        this.setState({ editItem: data }, () => {
            this.setState({ metadataSchemaFlag: true, action: "Update"})
        });
      }
      onRemoveItem = (data) => {
        let updateOptions = this.props.selectedPracticeFlowActivity.metaDataSchema.filter(option => option.name !== data.name)
        let message = <div className="confirmMessage">
            <h3>Delete Metadata Schema</h3>
            <label>{data.title}</label>
            <p>Are you sure to delete this metadata schema?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                // dispatch.lifeCycle.updatePlaybookActivities(updateOptions)
                this.onSubmitSchema(updateOptions)
            }
        });
      }
      setMetaDataFlag= async (flag,schema,shemaUpdationKey)=>{
        await this.setState({ modalFlag: flag, schema:schema,shemaUpdationKey:shemaUpdationKey });
      }
      onSubmitSchema = (schema) =>{
        let payload = {
            // _id: this.props.selectedPracticeFlowActivity._id,
            // data: {
            //     metaDataSchema: schema
            // },
            ...this.props.selectedPracticeFlowActivity,
        }
        payload["metaDataSchema"] = schema
        // dispatch.createPack.editActivityAsync(payload)
        dispatch.lifeCycle.updatePlaybookActivities(payload)
      }
    render() {
        const integrate = this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.some(int => int.isActive && int.id.id === "openai")
        const isPlaybookGenerated = this.props.selectedPracticeLibrary && 
        typeof this.props.selectedPracticeLibrary.playbookGenerationStatus !== 'undefined' && 
        this.props.selectedPracticeLibrary.playbookGenerationStatus >= 0 && this.props.selectedPracticeLibrary.status === 0;
        const { selectedPracticeFlowActivity } = this.props;
        const isProcessing = selectedPracticeFlowActivity &&
                             selectedPracticeFlowActivity.isLeafNode &&
                             selectedPracticeFlowActivity.isSmartActivity;
        const isPreProcessing = selectedPracticeFlowActivity &&
                             selectedPracticeFlowActivity.isLeafNode &&
                             !selectedPracticeFlowActivity.isSmartActivity;
        const isPostProcessing = selectedPracticeFlowActivity &&
                             selectedPracticeFlowActivity.isLeafNode &&
                             !selectedPracticeFlowActivity.isSmartActivity;
        let metaDataFlag = true;
        // if (this.isAuthor() || this.isAuthor()) {
        //   metaDataFlag = true;
        // }
        const errorLabel = <div className="customErrorLabel" />;
        let isAllowedToSeeAttachments = this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.filter(participant => { return participant.accountUserId.toString() === this.props.user._id.toString() || (participant.role === 'author' || participant.role === 'contributor') });
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let raci = this.props.selectedPracticeFlowActivity.raci;
        // let raciLength = raci ?
        //     (raci.r ? raci.r.length : 0 +
        //         raci.c ? raci.c.length : 0 +
        //             raci.i ? raci.i.length : 0) + 1 : 0;
        let raciLength = 0;
        if(raci && raci.r){
            raciLength+=raci.r.length
        }
        if(raci && raci.a){
            raciLength+=1;
        }
        if(raci && raci.c){
            raciLength+=raci.c.length
        }
        if(raci && raci.i){
            raciLength+=raci.i.length
        }
        let counts = {}

        if (this.props.selectedPracticeLibrary) {
            counts.notesLength = <Label>{this.props.selectedPracticeFlowActivity.notes && this.props.selectedPracticeFlowActivity.notes.length}</Label>
            counts.attachmentsLength = <Label>{this.props.selectedPracticeFlowActivity.attachments && this.props.selectedPracticeFlowActivity.attachments.length}</Label>
            counts.referencesLength = <Label>{this.props.selectedPracticeFlowActivity.references && this.props.selectedPracticeFlowActivity.references.length}</Label>
            counts.assignmentsLength = <Label>{raciLength}</Label>
            counts.dependenciesLength = <Label>{this.props.selectedPracticeFlowActivity.dependencies && this.props.selectedPracticeFlowActivity.dependencies.length}</Label>
        }

        return (
            <div className="accordianBox w_100">
                <div className={this.props.selectedPracticeLibrary.status === 0 ?
                    "accordianPanel w_100" : "accordianPanel w_100"}>
                    <Accordion
                        activeIndex={this.state.activeIndex}
                        onActivate={(activeIndex) => this.setState({ activeIndex })}
                        expandTool={expandTool}
                        horizontal
                        className="practiceFlowResourcePane hidden_Checkbox"
                        transitionDuration={this.props.transactionTime}
                        enableKeyboardNavigation={false}
                    >
                        {[
                            <div tabTitle="Detail">
                                <div className="acc-header">Details
                                {isPlaybookGenerated && this.props.selectedPracticeFlowActivity &&
                        this.props.selectedPracticeFlowActivity.parentActivity &&
                        !this.props.selectedPracticeFlowActivity.isLeafNode && integrate && <span> 
                            <span className='float-right'>
                            <Button
								size='mini'
								className="button-info"
                                style={{marginBottom:"12px"}}
								disabled={(this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.metaData && (this.props.selectedPracticeFlowActivity.metaData.generateActivitiesInProgress)) || this.state.webSearchLoading || this.props.generatingActivityDetails || this.generateStageActivitiesFlag()}
								onClick={this.generateActivities}>Generate Activities</Button> 
                            <Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
									<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', width: '100%' }}>This will delete the activities and generate new activities in this stage only</div>}
								/></span>    
                           <span className=' float-right'><Button
                               size='mini'
                               className="button-info"
                               style={{marginBottom:"12px"}}
                               disabled={(this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.metaData && (this.props.selectedPracticeFlowActivity.metaData.generateActivitiesInProgress)) || this.state.webSearchLoading || this.props.generatingActivityDetails || this.state.generateActivitiesFlag || (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.playbookGenerationStatus === 1)|| (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.activities && this.props.selectedPracticeFlowActivity.activities.length === 0)}
                               onClick={this.generateDetails}>
                               Generate Details</Button>
                               <Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
									<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', width: '300px', whiteSpace:'normal', wordWrap:"break-word" }}>This will generate new attachment links and metadata for activities in this stage only</div>}
								/></span>   
                            </span>}
                            {this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.isParentNode && this.props.selectedPracticeFlowActivity.isLeafNode && integrate && isPlaybookGenerated &&
                             <span className='float-right'> 
                            <Button
								size='mini'
								className="button-info"
                                style={{marginBottom:"12px"}}
								disabled={(this.state.webSearchLoading && this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.aiGenStatus === 0) || this.props.selectedPracticeLibrary.playbookGenerationStatus === 1 || this.props.generatingActivityDetails || (this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.metaData && this.props.selectedPracticeFlowActivity.metaData.generateActivityDetailsInProgress)}
								onClick={this.webSearch}>
                                     {this.state.webSearchLoading && this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.aiGenStatus === 0 &&
                    <React.Fragment>
                        <Icon name='circle notched' loading/>
                    </React.Fragment>}Generate Details</Button>
                    <Popup hoverable className="popupStyled " wide='very' position='bottom right' inverted trigger={
									<Icon style={{marginBottom:"10px",marginRight:"10px"}} name='info circle' size='large' />
								}
									content={<div style={{ display: 'block', width: '300px', whiteSpace:'normal', wordWrap:"break-word" }}>This will generate new attachment links and metadata for this one activity</div>}
								/>
                            </span>}
                                </div>
                                <Summary 
                                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                                    status={this.props.selectedPracticeLibrary.status}
                                    selectedPracticeLibrary = {this.props.selectedPracticeLibrary} 
                                    arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                    selectedAccount={this.props.selectedAccount}
                                    author = {this.isAuthor()}
                                />
                            </div>,
                            this.props.selectedPracticeLibrary.status !== 4 && this.props.selectedPracticeLibrary.status !==5 ? <div tabTitle={<div>Comments {counts.notesLength} </div>} key="Comment">
                                <div className="acc-header"> Comments {counts.notesLength}
                                    {(this.props.selectedPracticeLibrary.status === 0 || this.props.selectedPracticeLibrary.status === 1 || this.props.selectedPracticeLibrary.status === 2 || this.props.selectedPracticeLibrary.status === 3)
                                        && <Icon name='plus' className="cursor-pointer" color='green' onClick={() => this.notesClick(true, "addNote")} />
                                    }
                                </div>
                                <div>
                                    <Notes
                                        notes={this.props.selectedPracticeFlowActivity.notes}
                                        user={this.props.user}
                                        notesClick={this.notesClick}
                                        status={this.props.selectedPracticeLibrary.status}
                                        selectedData={this.props.selectedPracticeFlowActivity}
                                        arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                        string='playbookActivity'
                                        role={this.props.selectedOrganisation.role}
                                    />
                                </div>
                            </div> : null,
                            <div tabTitle={<div>References {counts.referencesLength} </div>}>
                                <div className="acc-header">References {counts.referencesLength}</div>
                                <References selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                                    category={this.props.selectedPracticeLibrary.category}
                                    status={this.props.selectedPracticeLibrary.status}
                                    arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                    user={this.props.user}
                                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                    nameOfHelpText='References Card'
                                    currentOrganization={this.props.currentOrganization}
                                />
                            </div>,
                            isAllowedToSeeAttachments ? <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
                                <div className="acc-header">Attachments {counts.attachmentsLength}

                                    {(this.props.selectedPracticeLibrary) && (this.props.selectedPracticeLibrary.status === 0 || (this.props.selectedPracticeLibrary.status === 4 && (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner())))? 
                                        <span className="pull-right" style={{ margin: "4px 0px" }}>
                                            <Button 
                                                className="button-info float-right" 
                                                style={{ padding: "7px 10px" }} 
                                                content='Upload File' 
                                                onClick={this.handleUppyModalClick} 
                                            />
                                            <Button 
                                                className="button-info float-right" 
                                                style={{ padding: "7px 10px" }} 
                                                content='Add Link' 
                                                onClick={() => this.setState({ linkOpen: true })} 
                                            />
                                        </span>
                                        : null}
                                </div>
                                <FileUploader
                                    data={this.props.selectedPracticeFlowActivity}
                                    action={this.addAttachment}
                                    openDashboard={this.state.openDashboard}
                                    handleUppyModalClick={this.handleUppyModalClick}
                                    entityName="activity"
                                    playbookStatus={this.props.selectedPracticeLibrary.status}
                                    isPublic={this.props.selectedPracticeLibrary.scope === "Public" ? true : false}
                                    selectedOrganization={this.props.selectedOrganisation}
                                    selectedPlaybook={this.props.selectedPracticeLibrary}
                                    currentOrganization={this.props.currentOrganization}
                                    user={this.props.user}
                                    to='playbookActivity'
                                    isAuthor={this.isAuthor()}
                                    isWorkspaceOwner={this.isWorkspaceOwner()}
                                    isContributor={this.isContributor()}
                                    status={this.props.selectedPracticeLibrary.status}
                                />


                            </div> : null,
                            <div tabTitle={<div>Assignments {counts.assignmentsLength} </div>}>
                                <Grid style={{ marginTop: "7.5px" }}>
                                    <Grid.Row>
                                        <Grid.Column width={8}>
                                            <div className="acc-header">Assignments {counts.assignmentsLength}</div>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                            {this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.isParentNode && this.props.selectedPracticeLibrary.status === 0 &&
                                                <Button className="button-info float-right" content='Propagate RACI' icon='sort content ascending' onClick={this.propagateChangesToChildren} />
                                            }
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <AssignRole
                                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                                    communityOptions={this.props.selectedPracticeLibrary.communities}
                                    activityActions={this.props.activityActions}
                                    status={this.props.selectedPracticeLibrary.status}
                                    editActivity={this.editActivity}
                                    arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                    nameOfHelpText='Assigned Roles Card'
                                />
                            </div>,
                            
                            this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity.isLeafNode ?
                                <div tabTitle={<div>Dependencies {counts.dependenciesLength} </div>}>
                                    <div className="acc-header">Dependencies {counts.dependenciesLength}</div>
                                    <Dependencies
                                        {...this.props}
                                        selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                                        activityOptions={this.props.selectedPracticeLibrary.activities}
                                        status={this.props.selectedPracticeLibrary.status}
                                        showChildren={true}
                                        arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                        name='Depends On Card'
                                    />
                                </div> : null,

                                <div tabTitle={<div>MetaData Schema</div>}>
                                <div className="acc-header">
                                  MetaData Schema 
                                  <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                    {(metaDataFlag && this.props.selectedPracticeFlowActivity &&
                                    (this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()))) ? (
                                        <Button
                                        disabled={!metaDataFlag}
                                        content="Edit JSON Schema"
                                        className="button-submit float-right "
                                        type="button"
                                        onClick={() => this.setSchemaJsonFlag(true)}
                                        />
                                    ) : null}
                                 {(metaDataFlag && this.props.selectedPracticeFlowActivity && (this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()))) ? (
                                    <Button
                                    disabled={!metaDataFlag}
                                    content="Add Schema"
                                    className="button-submit float-right"
                                    type="button"
                                    onClick={() => this.setMetadataSchemaModalFlag(true)}
                                    />
                                ) : null}
                                  </span>
                                  {/* <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                    {(this.props.selectedPracticeFlowActivity &&
                                    !this.props.selectedPracticeFlowActivity.metaDataSchema) ? (                       
                                    <Button
                                    content="Add MetaData"
                                    className="button-submit float-right "
                                    type="button"
                                    onClick={() => this.setMetadataSchemaModalFlag(true, this.props.selectedPracticeFlowActivity.metaDataSchema,"metaDataSchema")}
                                    />) : null}
                                  </span> */}
                                </div>
                                {this.props.selectedPracticeFlowActivity &&
                                this.props.selectedPracticeFlowActivity.metaDataSchema && this.props.selectedPracticeFlowActivity.metaDataSchema.length > 0 ? (
                                  <div className="resourcePaneOverflow">
                                    {/* <pre>
                                      {JSON.stringify(
                                        this.props.selectedPracticeFlowActivity.metaDataSchema,
                                        null,
                                        2
                                      )}
                                    </pre> */}
                                    {/* <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Input
                                                fluid
                                                label="First Name"
                                            />
                                            <Form.Input 
                                                fluid
                                                label="Text Box"
                                            />
                                            
                                        </Form.Group>
                                        <Button.Group size='mini'>
                                            <Button color='orange'><Icon name="edit" /></Button>
                                            <Button color='red'><Icon name="delete" /></Button>
                                            </Button.Group>
                                    </Form> */}
                                    <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={7}>
                                            <div className='acc-header'>Name Field</div>
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <div className='acc-header'>Type</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {this.props.selectedPracticeFlowActivity.metaDataSchema.map((m) => {
                                        return (
                                        <Grid.Row style={{ 'margin-bottom': '5px' }}>
                                            <Grid.Column width={7}>
                                            <Input style={{width: "200px"}} disabled placeholder="Title" value={m.title} />
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <Input style={{width: "200px"}} disabled placeholder="Text Box" value={m.type} />
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                            {(this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()))?
                                                <Button icon="edit alternate" className="trash-color" onClick={() => this.setItemToEdit(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>:null}
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                              {(this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()))?
                                                <Button icon="trash alternate" className="trash-color" onClick={() => this.onRemoveItem(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>:null}
                                            
                                        </Grid.Column>
                                        </Grid.Row>
                                        )
                                    })}
                                        {/* <Grid.Column width={7}>
                                            <Input style={{width: "200px"}} placeholder="First Name" />
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <Input style={{width: "200px"}} placeholder="Text Box" />
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                            <Button icon="edit alternate" className="trash-color" style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }} onClick={() => this.setItemToEdit(true,this.props.selectedPracticeFlowActivity.metaDataSchema )}></Button>
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                            <Button icon="trash alternate" className="trash-color" style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>
                                        </Grid.Column> */}
                                </Grid>
                                  </div>
                                ) : <span className="clr-orange">No metaData to display</span>}
                              </div>,

                                //metadata
                                <div tabTitle={<div>MetaData</div>}>
                                <div className="acc-header">
                                  MetaData
                                  <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                   {(metaDataFlag && this.props.selectedPracticeFlowActivity &&
                                    (this.props.selectedPracticeLibrary.status === 0 || (this.isAuthor() || this.isContributor() || this.isWorkspaceOwner()))) ? (
                                        <Button
                                        disabled={!metaDataFlag}
                                        content="Edit MetaData"
                                        className="button-submit float-right "
                                        type="button"
                                        onClick={() => this.setMetaDataFlag(true,this.props.selectedPracticeFlowActivity.metaData,"metaData")}
                                        />
                                    ) : null}
                                  </span>
                                  {/* <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                    {(this.props.selectedPracticeFlowActivity &&
                                    !this.props.selectedPracticeFlowActivity.metaData) ? (                       
                                    <Button
                                    content="Add MetaData"
                                    className="button-submit float-right "
                                    type="button"
                                    onClick={() => this.setMetaDataFlag(true,this.props.selectedPracticeFlowActivity.metaData,"metaData")}
                                    />) : null}
                                  </span> */}
                                </div>
                                {this.props.selectedPracticeFlowActivity &&
                                this.props.selectedPracticeFlowActivity.metaData ? (
                                  <div className="resourcePaneOverflow">
                                    <pre>
                                      {JSON.stringify(
                                        this.props.selectedPracticeFlowActivity.metaData,
                                        null,
                                        2
                                      )}
                                    </pre>
                                  </div>
                                ) : <span className="clr-orange">No metaData to display</span>}
                              </div>,
                            //   isProcessing ? <div tabTitle={<div>Processing</div>}>
                            //     <ProcessComponent {...this.props} processingType="Processing" /></div>:"",
                            //   isPreProcessing ? <div tabTitle={<div>Pre Processing</div>}>
                            //     <ProcessComponent {...this.props} processingType="Pre Processing" /></div>:"",
                            //   isPostProcessing ? <div tabTitle={<div>Post Processing</div>}>
                            //     <ProcessComponent {...this.props} processingType="Post Processing" /></div>:""
                            isProcessing ? (
                                <div tabTitle={<div>Processing</div>}>
                                    <ProcessComponent
                                        key={`${this.props.selectedPracticeFlowActivity._id}-processing`}
                                        {...this.props}
                                        processingType="Processing"
                                        isAuthor={this.isAuthor()}
                                        status = {this.props.selectedPracticeLibrary.status}
                                        isWorkspaceOwner={this.isWorkspaceOwner()}
                                        isContributor={this.isContributor()}  
                                    />
                                </div>
                            ) : "",
                            
                            isPreProcessing ? (
                                <div tabTitle={<div>Pre Processing</div>}>
                                    <ProcessComponent
                                        key={`${this.props.selectedPracticeFlowActivity._id}-preprocessing`}
                                        {...this.props}
                                        processingType="Pre Processing"
                                        isAuthor={this.isAuthor()}
                                        status = {this.props.selectedPracticeLibrary.status}
                                        isWorkspaceOwner={this.isWorkspaceOwner()}
                                        isContributor={this.isContributor()}  
                                    />
                                </div>
                            ) : "",
                            
                            isPostProcessing ? (
                                <div tabTitle={<div>Post Processing</div>}>
                                    <ProcessComponent
                                        key={`${this.props.selectedPracticeFlowActivity._id}-postprocessing`}
                                        {...this.props}
                                        processingType="Post Processing"
                                        isAuthor={this.isAuthor()}
                                        status = {this.props.selectedPracticeLibrary.status}
                                        isWorkspaceOwner={this.isWorkspaceOwner()}
                                        isContributor={this.isContributor()}  
                                    />
                                </div>
                            ) : ""
                                   
                                
                            // this.props.selectedPracticeFlowActivity &&
                            //     this.props.selectedAccount && this.props.selectedAccount.integrations && 
                            //     this.props.selectedAccount.integrations.length > 0 ? (
                            //       <SmartIntegration
                            //         selectedAccount={this.props.selectedAccount}
                            //         selectedPracticeFlowActivity={
                            //           this.props.selectedPracticeFlowActivity
                            //         }
                            //       />
                            //     ) : null,

                        ].filter(elem => !!elem)}
                    </Accordion>

                    <NotesModal notes={this.props.selectedPracticeFlowActivity.notes}
                        selectedData={this.props.selectedPracticeFlowActivity}
                        user={this.props.user}
                        open={this.state.openNotesModel}
                        notesClick={this.notesClick}
                        currentNote={this.props.currentNote}
                        clickStatus={this.state.clickStatus}
                        string='playbookActivity' />

                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.name}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.url}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ url: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Add Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal>
                </div>
                <ShowPlaybookMetaData
                    open={this.state.modalFlag}
                    setMetaDataFlag={this.setMetaDataFlag}
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                    metaDataSchema={
                        this.state.schema
                    }
                    view="sequence"
                    shemaUpdationKey={this.state.shemaUpdationKey}
                />
                <RegenatePlaybookActivitiesModal generateDetailsOpen={this.state.generateDetailsOpen} {...this.props} generateDetails={this.generateDetails} reference="stage"/>
                {/* <ShowPlaybookMetaDataSchema
                    open={this.state.metadataSchemaFlag}
                    setMetadataSchemaModalFlag={this.setMetadataSchemaModalFlag}
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                    metaDataSchema={
                        this.state.schema
                    }
                    view="sequence"
                    shemaUpdationKey={this.state.shemaUpdationKey}
                /> */} 
                <ShowPlaybookMetaDataSchema
                    open={this.state.schemaJSON}
                    setMetaDataFlag={this.setSchemaJsonFlag}
                    metaDataSchema={this.props.selectedPracticeFlowActivity.metaDataSchema}
                    onSubmitSchema={this.onSubmitSchema}
                 />
                {this.state.metadataSchemaFlag &&
                    <SchemaModalForm
                        open={this.state.metadataSchemaFlag}
                        close={this.close}
                        schemaOpen={this.setMetadataSchemaModalFlag}
                        onSubmitSchema={this.onSubmitSchema}
                        schema={this.props.selectedPracticeFlowActivity.metaDataSchema}
                        selectedItem={this.state.editItem}
                        action={this.state.action}
                    /> }
            </div >
        )
    }
}

export default PracticeCommunitySwimLineCommanPane;